import { Directive, forwardRef, Attribute, Input } from '@angular/core';
import { Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[validateIpCount][ngModel]',
  providers: [
      {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => IpCountValidator),
          multi: true
    }
  ]
})

export class IpCountValidator implements Validator {
    @Input('max') max: number;
    constructor() {}
    validate(c: AbstractControl): { [key: string]: any }  {
        let returnValue = null;
        if (c.value > this.max || c.value < 1) {
            returnValue = {
                validateIpCount: false
            };
        }
        return returnValue;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/network/gateways/ip-count-validator.ts